"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoDBToolboxError = void 0;
class DynamoDBToolboxError extends Error {
    constructor(code, { message, path, payload }) {
        super(message);
        this.code = code;
        this.path = path;
        this.payload = payload;
    }
}
exports.DynamoDBToolboxError = DynamoDBToolboxError;
DynamoDBToolboxError.match = (error, prefix = '') => error instanceof DynamoDBToolboxError && error.code.startsWith(prefix);
